import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLiveSession } from '@/state/LiveSessionContext';

function fmt(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  if (h > 0) return `${h}:${m.toString().padStart(2, '0')}:${ss.toString().padStart(2, '0')}`;
  return `${m}:${ss.toString().padStart(2, '0')}`;
}

export function LiveSessionBar() {
  const session = useLiveSession();
  const loc = useLocation();
  const nav = useNavigate();
  const { t } = useTranslation();
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!session.active) return;
    const id = window.setInterval(() => setTick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [session.active]);

  if (!session.active) return null;
  if (loc.pathname === '/train/session') return null;

  const elapsed = session.active.kind === 'cardio'
    ? session.totalCardioElapsedSec()
    : (Date.now() - new Date(session.active.startedAt).getTime()) / 1000;

  return (
    <button type="button" className="live-bar" onClick={() => nav('/train/session')}>
      <div className="live-bar__dot" />
      <div className="live-bar__label">
        {session.active.kind === 'cardio' ? t('components.liveBarCardio') : t('components.liveBarLift')} · {fmt(elapsed)}
      </div>
      <div className="live-bar__cta">{t('components.liveBarReturn')}</div>
    </button>
  );
}
